import { render, staticRenderFns } from "./ClientBook.vue?vue&type=template&id=5408f927"
import script from "./ClientBook.vue?vue&type=script&lang=js"
export * from "./ClientBook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports